import { getNotificationServiceForSharepoint, getShareServiceForSharepoint } from '@fluidx/host-ux';
import type { NotificationService, ShareService } from '@fluidx/office-fluid-types';
import { Locale, resolveLocale } from '@fluidx/utilities';
import { getGuid } from 'owa-guid';
import { getCurrentLanguage } from 'owa-localize';
import { AppHostContext } from './AppHostContext';
import { AppNotificationService } from './AppNotificationService';
import { AppShareService } from './AppShareService';
import { OUTLOOK_APP_NAME } from '../../constants';

export function getNotificationServicePromise(
    tokenProvider,
    fileId,
    driveId,
    siteUrl,
    fluidLogger,
    sessionId,
    wellModifierFunction?
): Promise<NotificationService> {
    if (wellModifierFunction) {
        return new Promise(resolve => {
            resolve(new AppNotificationService(wellModifierFunction));
        });
    }
    return getNotificationServiceForSharepoint({
        tokenProvider,
        fileId: fileId,
        driveId: driveId,
        siteUrl: siteUrl,
        logger: fluidLogger,
        correlationId: sessionId,
    });
}

export function getShareServicePromise(
    tokenProvider,
    fluidLogger,
    fileId,
    driveId,
    siteUrl,
    wellModifierFunction?
): Promise<ShareService> {
    if (wellModifierFunction) {
        return new Promise(resolve => {
            resolve(new AppShareService());
        });
    }

    const locale = getCurrentLanguage();
    const fluidLocale: Locale = resolveLocale(locale);

    return getShareServiceForSharepoint({
        tokenProvider,
        logger: fluidLogger,
        appName: OUTLOOK_APP_NAME,
        bootDocumentInfo: {
            fileId: fileId,
            driveId: driveId,
            siteUrl: siteUrl,
        },
        localization: {
            locale: fluidLocale,
        },
    });
}

export function getHostContext(sessionId: string, scenarioName: string, scenarioStartTime: number) {
    const appHostContext = new AppHostContext(
        sessionId,
        scenarioName,
        getGuid(),
        scenarioStartTime
    );
    return appHostContext;
}
